import type { IconStyle } from 'app/src/model'
import type { FC } from 'react'

export const Diamond: FC<IconStyle> = ({ width, height, stroke, fill, className }) => {
  return (
    <svg
      width={`${width}px`}
      height={`${height ?? width}px`}
      viewBox='0 0 19 19'
      className={className}
      fill={'none'}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.76212 18.2639L18.4412 8.43697L16.178 4.6875H3.34916L1.08594 8.43697L9.76506 18.2639'
        stroke={stroke ?? fill}
        strokeWidth='0.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M1.25781 8.4375H6.00499' stroke={stroke ?? fill} strokeWidth='0.75' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M8.21094 8.4375H18.2645' stroke={stroke ?? fill} strokeWidth='0.75' strokeLinecap='round' strokeLinejoin='round' />
      <path
        d='M5.96094 8.42969L9.75456 18.1242'
        stroke={stroke ?? fill}
        strokeWidth='0.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.94446 8.38576L4.41406 6.23438'
        stroke={stroke ?? fill}
        strokeWidth='0.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.54731 4.75781L6.01562 8.36307'
        stroke={stroke ?? fill}
        strokeWidth='0.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13.5641 8.4375L9.77344 18.132'
        stroke={stroke ?? fill}
        strokeWidth='0.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13.5781 8.38763L16.1651 4.75'
        stroke={stroke ?? fill}
        strokeWidth='0.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.97656 4.75781L13.5083 8.36307'
        stroke={stroke ?? fill}
        strokeWidth='0.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M9.76562 2.4642V1.10156' stroke={stroke ?? fill} strokeWidth='0.75' strokeLinecap='round' strokeLinejoin='round' />
      <path
        d='M14.0234 2.46244L14.9446 1.27344'
        stroke={stroke ?? fill}
        strokeWidth='0.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.49931 2.46244L4.57812 1.27344'
        stroke={stroke ?? fill}
        strokeWidth='0.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
export const GoldBar: FC<IconStyle> = ({ width, height, stroke, fill, className }) => {
  return (
    <svg
      width={`${width}px`}
      height={`${height ?? (24 / 19) * width}px`}
      className={className}
      viewBox='0 0 24 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5.69531 12.3499L6.69545 9.51562H10.9868L12.6068 13.8996'
        stroke={stroke ?? fill}
        strokeWidth='0.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.6094 13.8996L14.2326 9.51562'
        stroke={stroke ?? fill}
        strokeWidth='0.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.6719 9.51562H18.5225L20.1426 13.9635'
        stroke={stroke ?? fill}
        strokeWidth='0.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.41406 7.90458L10.4494 5.07031H14.7407L16.2936 9.45432'
        stroke={stroke ?? fill}
        strokeWidth='0.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M2.60616 18.4199H0.835938L2.45598 13.9688H6.74732L8.37055 18.3528'
        stroke={stroke ?? fill}
        strokeWidth='0.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.36719 18.356L9.92012 14.0391'
        stroke={stroke ?? fill}
        strokeWidth='0.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.3438 14.0391L15.8999 18.356'
        stroke={stroke ?? fill}
        strokeWidth='0.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.8984 18.356L17.4546 14.0391'
        stroke={stroke ?? fill}
        strokeWidth='0.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.53394 13.9688H21.817L23.4402 18.4199H4.50781'
        stroke={stroke ?? fill}
        strokeWidth='0.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.1406 2.43151L12.1502 1'
        stroke={stroke ?? fill}
        strokeWidth='0.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.38502 5.46284L6.07812 4.38281'
        stroke={stroke ?? fill}
        strokeWidth='0.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M16.8828 5.46284L18.1865 4.38281'
        stroke={stroke ?? fill}
        strokeWidth='0.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const PiggyBank: FC<IconStyle> = ({ width, height, stroke, fill, className }) => {
  return (
    <svg
      width={`${width}px`}
      height={`${height ?? (21 / 20) * width}px`}
      viewBox='0 0 21 20'
      className={className}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.0524 7.4012C7.0524 7.52331 6.953 7.62271 6.83089 7.62271C6.70877 7.62271 6.60938 7.52331 6.60938 7.4012C6.60938 7.27908 6.70877 7.17969 6.83089 7.17969C6.953 7.17969 7.0524 7.27908 7.0524 7.4012Z'
        fill='white'
        stroke={stroke ?? fill}
        strokeWidth='1.10373'
        strokeMiterlimit='10'
      />
      <path
        d='M18.0547 8.08702L20.0199 7.13281'
        stroke={stroke ?? fill}
        strokeWidth='0.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.7192 5.33202C17.3664 6.50774 18.4285 8.32811 18.4285 10.3615C18.4285 12.8805 16.7842 15.07 14.4328 16.1179V18.1627C14.4328 18.475 14.1772 18.7306 13.8648 18.7306H12.6209C12.3085 18.7306 12.0529 18.475 12.0529 18.1627V16.7399C11.8201 16.7598 11.5673 16.7711 11.3288 16.7711H10.2326C9.994 16.7711 9.74977 16.7598 9.5169 16.7399V18.1627C9.5169 18.475 9.26131 18.7306 8.94892 18.7306H7.70505C7.39266 18.7306 7.13707 18.475 7.13707 18.1627V16.1293C7.13707 16.1293 7.10583 16.1123 7.09731 16.1094C5.595 15.4364 4.38805 14.272 3.71499 12.8776H2.21553C2.21553 12.8776 0.542831 7.14388 1.53111 7.48466C2.73807 7.89929 3.80587 7.5017 3.86835 7.46194C3.94787 7.41651 3.98762 7.36255 3.98762 7.36255C4.58968 6.33451 5.48141 5.47686 6.56625 4.8748L6.58045 4.85776L6.54637 2.33594C7.89816 2.33594 9.0256 4.04271 9.0256 4.04271H9.05968C9.44306 3.98592 9.82929 3.94616 10.2326 3.94616H11.0078'
        stroke={stroke ?? fill}
        strokeWidth='0.75'
        strokeLinejoin='round'
      />
      <path
        d='M13.9305 1.04688C14.9244 1.04688 15.7281 1.8534 15.7281 2.84453C15.7281 3.83565 14.9244 4.64218 13.9305 4.64218C12.9365 4.64218 12.1328 3.83565 12.1328 2.84453C12.1328 1.8534 12.9393 1.04688 13.9305 1.04688Z'
        stroke={stroke ?? fill}
        strokeWidth='0.75'
        strokeLinejoin='round'
      />
      <path
        d='M10.2891 6.17212C10.2891 6.17212 11.9419 5.77454 13.305 6.35388'
        stroke={stroke ?? fill}
        strokeWidth='1.10373'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const Locker: FC<IconStyle> = ({ width, height, fill, className }) => {
  return (
    <svg
      className={className}
      width={`${width}px`}
      height={`${height ?? (4 / 5) * width}px`}
      viewBox='0 0 8 10'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6.67994 4.39977H5.55377V3.07037C5.55377 2.4204 5.207 1.81957 4.64415 1.49498C4.08129 1.16999 3.38777 1.16999 2.82485 1.49498C2.262 1.81955 1.91523 2.42041 1.91523 3.07037V4.39977H0.789062V3.07037C0.789062 2.01811 1.35064 1.04565 2.26201 0.519578C3.17338 -0.00649859 4.29569 -0.00655328 5.20703 0.519578C6.11837 1.04571 6.67998 2.01811 6.67998 3.07037L6.67994 4.39977Z'
        fill={fill}
      />
      <path
        d='M6.7468 4.39844H0.733878C0.423414 4.39844 0.171877 4.64997 0.171877 4.96044V9.06016C0.171023 9.36977 0.421709 9.62174 0.73132 9.62301H6.74425C6.89372 9.62301 7.03678 9.56365 7.14226 9.45817C7.24774 9.35226 7.30667 9.20921 7.30625 9.06016V4.96044C7.30625 4.65083 7.05599 4.39972 6.7468 4.39844ZM4.14047 7.42108V8.18636H3.33761V7.42108C2.99767 7.23745 2.82599 6.84627 2.9208 6.47174C3.01561 6.09721 3.35255 5.83458 3.73904 5.83458C4.12553 5.83458 4.46247 6.09721 4.55728 6.47174C4.65209 6.84627 4.48041 7.23745 4.14047 7.42108Z'
        fill={fill}
      />
    </svg>
  )
}

export const ChartIcon = (
  props: React.PropsWithChildren<{
    backgroundColor: string
    borderColor: string
    position?: string
    className?: string
    withLocker: boolean
    height?: string
    width?: string
    ariaLabel?: string
  }>,
) => {
  const { position, backgroundColor, borderColor, height, width, children, withLocker, className } = props
  const iconStyles: React.CSSProperties = {
    left: position ?? 'unset',
    backgroundColor: backgroundColor,
    border: `2px solid ${borderColor}`,
    height: height ?? '58px',
    width: width ?? '58px',
  }
  return (
    <div className={`${className}`} style={iconStyles}>
      {withLocker && (
        <div className='absolute right-[-2px] top-[-2px] flex h-[35%] w-[35%] items-center justify-center'>
          <Locker width={30} fill={'var(--primary-color)'} />
        </div>
      )}
      {children}
    </div>
  )
}

export const ShoppingCartIcon = () => {
  return (
    <svg width='37' height='47' viewBox='0 0 37 47' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M35.5369 0.128525C35.3702 0.0414076 35.183 0.00117233 34.9952 0.0121106C34.8075 0.0230489 34.6262 0.0847503 34.4707 0.190634L29.4813 3.58595L24.3055 0.180283C24.1365 0.0688599 23.9386 0.00946846 23.7362 0.00946846C23.5338 0.00946846 23.3358 0.0688599 23.1668 0.180283L18.0428 3.58595L12.9291 0.180283C12.7601 0.0688727 12.5622 0.0094886 12.3598 0.0094886C12.1574 0.0094886 11.9594 0.0688727 11.7905 0.180283L6.61467 3.58595L1.61487 0.180283C1.45941 0.0743989 1.27813 0.0126971 1.09035 0.0017588C0.902581 -0.00917947 0.71536 0.0310558 0.548659 0.118173C0.382177 0.204745 0.242845 0.335622 0.146034 0.496365C0.0492223 0.657108 -0.00130558 0.84147 2.5641e-05 1.02911V45.0233C0.000817662 45.2975 0.110133 45.5604 0.304091 45.7543C0.498049 45.9483 0.760885 46.0576 1.03518 46.0584H35.0504C35.3247 46.0576 35.5875 45.9483 35.7815 45.7543C35.9755 45.5604 36.0848 45.2975 36.0856 45.0233V1.02911C36.0855 0.84313 36.0342 0.660757 35.9375 0.501928C35.8407 0.343098 35.7022 0.213924 35.5369 0.128525ZM34.0153 43.9984H2.07034V2.99591L6.02463 5.68731C6.19356 5.80274 6.39299 5.86535 6.59757 5.86719C6.80216 5.86903 7.00268 5.81003 7.17366 5.69767L12.3494 2.28165L17.4735 5.68731C17.6443 5.79877 17.844 5.85812 18.048 5.85812C18.252 5.85812 18.4516 5.79877 18.6225 5.68731L23.7362 2.28165L28.9119 5.69767C29.0829 5.81003 29.2834 5.86903 29.488 5.86719C29.6926 5.86535 29.892 5.80274 30.061 5.68731L34.0153 2.99591V43.9984Z'
        fill='var(--primary-color)'
      ></path>
      <path
        d='M26.4373 36.7032H9.66777C9.39323 36.7032 9.12994 36.8122 8.93581 37.0063C8.74168 37.2005 8.63262 37.4638 8.63262 37.7383C8.63262 38.0129 8.74168 38.2761 8.93581 38.4703C9.12994 38.6644 9.39323 38.7735 9.66777 38.7735H26.4373C26.7118 38.7735 26.9751 38.6644 27.1693 38.4703C27.3634 38.2761 27.4725 38.0129 27.4725 37.7383C27.4725 37.4638 27.3634 37.2005 27.1693 37.0063C26.9751 36.8122 26.7118 36.7032 26.4373 36.7032ZM17.7938 29.8194C17.7938 29.2768 17.6329 28.7465 17.3314 28.2953C17.03 27.8442 16.6016 27.4926 16.1003 27.285C15.5991 27.0774 15.0475 27.0231 14.5154 27.1289C13.9833 27.2348 13.4945 27.496 13.1109 27.8797C12.7272 28.2633 12.466 28.7521 12.3601 29.2842C12.2543 29.8163 12.3086 30.3679 12.5162 30.8691C12.7239 31.3704 13.0755 31.7988 13.5266 32.1002C13.9777 32.4016 14.508 32.5625 15.0506 32.5625C15.7777 32.5613 16.4747 32.2719 16.9889 31.7577C17.5031 31.2435 17.7925 30.5465 17.7938 29.8194ZM14.3777 29.8194C14.3777 29.6863 14.4172 29.5562 14.4911 29.4455C14.5651 29.3349 14.6701 29.2487 14.7931 29.1977C14.916 29.1468 15.0513 29.1335 15.1819 29.1594C15.3124 29.1854 15.4323 29.2495 15.5264 29.3436C15.6205 29.4377 15.6845 29.5576 15.7105 29.6881C15.7365 29.8186 15.7231 29.9539 15.6722 30.0769C15.6213 30.1998 15.5351 30.3049 15.4244 30.3788C15.3138 30.4528 15.1837 30.4922 15.0506 30.4922C14.9622 30.4924 14.8746 30.4751 14.7929 30.4414C14.7112 30.4076 14.6369 30.3581 14.5744 30.2955C14.5119 30.233 14.4623 30.1588 14.4286 30.0771C14.3948 29.9953 14.3776 29.9078 14.3777 29.8194ZM26.7375 29.8194C26.7375 29.2768 26.5766 28.7465 26.2752 28.2953C25.9738 27.8442 25.5453 27.4926 25.0441 27.285C24.5429 27.0774 23.9913 27.0231 23.4592 27.1289C22.927 27.2348 22.4383 27.496 22.0546 27.8797C21.671 28.2633 21.4097 28.7521 21.3039 29.2842C21.198 29.8163 21.2524 30.3679 21.46 30.8691C21.6676 31.3704 22.0192 31.7988 22.4703 32.1002C22.9214 32.4016 23.4518 32.5625 23.9943 32.5625C24.7215 32.5613 25.4185 32.2719 25.9327 31.7577C26.4468 31.2435 26.7362 30.5465 26.7375 29.8194ZM23.3215 29.8194C23.3215 29.6863 23.3609 29.5562 23.4349 29.4455C23.5088 29.3349 23.6139 29.2487 23.7368 29.1977C23.8598 29.1468 23.9951 29.1335 24.1256 29.1594C24.2561 29.1854 24.376 29.2495 24.4701 29.3436C24.5642 29.4377 24.6283 29.5576 24.6543 29.6881C24.6802 29.8186 24.6669 29.9539 24.616 30.0769C24.565 30.1998 24.4788 30.3049 24.3682 30.3788C24.2575 30.4528 24.1274 30.4922 23.9943 30.4922C23.9059 30.4924 23.8184 30.4751 23.7366 30.4414C23.6549 30.4076 23.5807 30.3581 23.5182 30.2955C23.4556 30.233 23.4061 30.1588 23.3723 30.0771C23.3386 29.9953 23.3213 29.9078 23.3215 29.8194ZM26.8824 15.3582H13.2391L13.0217 14.0436C12.8992 13.315 12.5218 12.6536 11.9567 12.1777C11.3916 11.7017 10.6757 11.4421 9.93692 11.4453H9.22266C8.94812 11.4453 8.68482 11.5544 8.49069 11.7485C8.29656 11.9427 8.1875 12.206 8.1875 12.4805C8.1875 12.755 8.29656 13.0183 8.49069 13.2125C8.68482 13.4066 8.94812 13.5157 9.22266 13.5157H9.93692C10.1867 13.5165 10.4282 13.605 10.6194 13.7659C10.8105 13.9267 10.939 14.1496 10.9824 14.3955L12.6594 24.2813C12.7818 25.0099 13.1593 25.6712 13.7244 26.1472C14.2894 26.6231 15.0053 26.8827 15.7441 26.8795H25.2883C25.5628 26.8795 25.8261 26.7705 26.0202 26.5763C26.2144 26.3822 26.3234 26.1189 26.3234 25.8444C26.3234 25.5698 26.2144 25.3065 26.0202 25.1124C25.8261 24.9183 25.5628 24.8092 25.2883 24.8092H15.7441C15.4944 24.8084 15.2528 24.7198 15.0617 24.559C14.8706 24.3982 14.7421 24.1753 14.6986 23.9293L14.6883 23.8465H23.3318C23.9966 23.8473 24.6442 23.6358 25.1804 23.243C25.7166 22.8501 26.1134 22.2964 26.3131 21.6623L27.8762 16.7039C27.9262 16.5492 27.9382 16.3847 27.9112 16.2243C27.8842 16.0639 27.8189 15.9124 27.7209 15.7826C27.623 15.6524 27.4964 15.5464 27.3511 15.4729C27.2057 15.3993 27.0453 15.3601 26.8824 15.3582ZM24.3359 21.0412C24.2697 21.2553 24.1363 21.4424 23.9554 21.5748C23.7746 21.7071 23.5559 21.7778 23.3318 21.7762H14.3363L13.6014 17.4285H25.4746L24.3359 21.0412Z'
        fill='var(--primary-color)'
      ></path>
    </svg>
  )
}

export const VoucherIcon = () => {
  return (
    <svg width='36' height='49' viewBox='0 0 36 49' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M34.3704 1.89062V47.8906H22.3593C22.4137 47.6099 22.4422 47.3247 22.4444 47.0388C22.4444 45.9091 21.9957 44.8258 21.1969 44.027C20.3982 43.2283 19.3148 42.7795 18.1852 42.7795C17.0556 42.7795 15.9722 43.2283 15.1734 44.027C14.3747 44.8258 13.9259 45.9091 13.9259 47.0388C13.9281 47.3247 13.9567 47.6099 14.0111 47.8906H2V1.89062H14.0111C13.9566 2.17136 13.9281 2.45651 13.9259 2.74248C13.9259 3.8721 14.3747 4.95546 15.1734 5.75423C15.9722 6.55299 17.0556 7.00174 18.1852 7.00174C19.3148 7.00174 20.3982 6.55299 21.1969 5.75423C21.9957 4.95546 22.4444 3.8721 22.4444 2.74248C22.4422 2.45651 22.4137 2.17136 22.3593 1.89062H34.3704Z'
        stroke='var(--primary-color)'
        strokeWidth='2.04444'
        strokeLinecap='round'
        strokeLinejoin='round'
      ></path>
      <path
        d='M2 34.2578H34.3704'
        stroke='var(--primary-color)'
        strokeWidth='2.04444'
        strokeLinecap='round'
        strokeLinejoin='round'
      ></path>
    </svg>
  )
}

export const GiftCardIcon = () => {
  return (
    <svg width='37' height='48' viewBox='0 0 37 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M2.35 0.890625C1.72674 0.890625 1.12901 1.13821 0.688299 1.57892C0.247588 2.01963 0 2.61737 0 3.24063V45.5406C0 46.1639 0.247588 46.7616 0.688299 47.2023C1.12901 47.643 1.72674 47.8906 2.35 47.8906H33.6833C34.3066 47.8906 34.9043 47.643 35.345 47.2023C35.7857 46.7616 36.0333 46.1639 36.0333 45.5406V3.24063C36.0333 2.61737 35.7857 2.01963 35.345 1.57892C34.9043 1.13821 34.3066 0.890625 33.6833 0.890625H2.35ZM34.4667 3.24063V45.5406C34.4667 45.7484 34.3841 45.9476 34.2372 46.0945C34.0903 46.2414 33.8911 46.324 33.6833 46.324H2.35C2.14225 46.324 1.943 46.2414 1.7961 46.0945C1.6492 45.9476 1.56667 45.7484 1.56667 45.5406V3.24063C1.56667 3.03287 1.6492 2.83363 1.7961 2.68672C1.943 2.53982 2.14225 2.45729 2.35 2.45729H33.6833C33.8911 2.45729 34.0903 2.53982 34.2372 2.68672C34.3841 2.83363 34.4667 3.03287 34.4667 3.24063ZM10.9667 25.9573H25.0667C25.2744 25.9573 25.4737 25.8748 25.6206 25.7279C25.7675 25.581 25.85 25.3817 25.85 25.174V12.6406C25.85 12.4329 25.7675 12.2336 25.6206 12.0867C25.4737 11.9398 25.2744 11.8573 25.0667 11.8573H23.3284L22.6932 9.31773C22.6662 9.20914 22.6162 9.10759 22.5466 9.01993C22.4771 8.93228 22.3896 8.86054 22.29 8.80955C22.1903 8.75856 22.081 8.7295 21.9692 8.72433C21.8574 8.71916 21.7458 8.738 21.6419 8.77958L18.0167 10.2303L14.3914 8.77958C14.2875 8.738 14.1759 8.71916 14.0641 8.72433C13.9524 8.7295 13.843 8.75856 13.7434 8.80955C13.6438 8.86054 13.5562 8.93228 13.4867 9.01993C13.4171 9.10759 13.3672 9.20914 13.3402 9.31773L12.7049 11.8573H10.9667C10.7589 11.8573 10.5597 11.9398 10.4128 12.0867C10.2659 12.2336 10.1833 12.4329 10.1833 12.6406V25.174C10.1833 25.3817 10.2659 25.581 10.4128 25.7279C10.5597 25.8748 10.7589 25.9573 10.9667 25.9573ZM24.2833 24.3906H20.3667V21.2573H24.2833V24.3906ZM24.2833 19.6906H20.3667V18.124H24.2833V19.6906ZM22.7167 13.424H24.2833V16.5573H20.3667V13.424H22.7167ZM18.8 11.6043L21.3913 10.5679L21.7132 11.8573H18.8V11.6043ZM18.8 13.424V24.3906H17.2333V13.424H18.8ZM14.6421 10.5679L17.2333 11.6043V11.8573H14.3201L14.6421 10.5679ZM11.75 13.424H15.6667V16.5573H11.75V13.424ZM11.75 18.124H15.6667V19.6906H11.75V18.124ZM11.75 21.2573H15.6667V24.3906H11.75V21.2573ZM29.7667 34.574C29.7667 34.7817 29.6841 34.981 29.5372 35.1279C29.3903 35.2748 29.1911 35.3573 28.9833 35.3573H7.05C6.84225 35.3573 6.643 35.2748 6.4961 35.1279C6.3492 34.981 6.26667 34.7817 6.26667 34.574C6.26667 34.3662 6.3492 34.167 6.4961 34.0201C6.643 33.8732 6.84225 33.7906 7.05 33.7906H28.9833C29.1911 33.7906 29.3903 33.8732 29.5372 34.0201C29.6841 34.167 29.7667 34.3662 29.7667 34.574ZM29.7667 39.274C29.7667 39.4817 29.6841 39.681 29.5372 39.8279C29.3903 39.9748 29.1911 40.0573 28.9833 40.0573H7.05C6.84225 40.0573 6.643 39.9748 6.4961 39.8279C6.3492 39.681 6.26667 39.4817 6.26667 39.274C6.26667 39.0662 6.3492 38.867 6.4961 38.7201C6.643 38.5732 6.84225 38.4906 7.05 38.4906H28.9833C29.1911 38.4906 29.3903 38.5732 29.5372 38.7201C29.6841 38.867 29.7667 39.0662 29.7667 39.274ZM21.9333 29.0906C22.1411 29.0906 22.3403 29.1732 22.4872 29.3201C22.6341 29.467 22.7167 29.6662 22.7167 29.874C22.7167 30.0817 22.6341 30.281 22.4872 30.4279C22.3403 30.5748 22.1411 30.6573 21.9333 30.6573H14.1C13.8922 30.6573 13.693 30.5748 13.5461 30.4279C13.3992 30.281 13.3167 30.0817 13.3167 29.874C13.3167 29.6662 13.3992 29.467 13.5461 29.3201C13.693 29.1732 13.8922 29.0906 14.1 29.0906H21.9333Z'
        fill='var(--primary-color)'
      ></path>
    </svg>
  )
}
